// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Options/MethodOptions.proto (syntax proto3)
/* eslint-disable */

import type { GenExtension, GenFile } from "@bufbuild/protobuf/codegenv2";
import { extDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import type { MethodOptions } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";
import type { AuthorizationPolicy } from "../Enumerations/AuthorizationPolicy_pb";
import { file_Enumerations_AuthorizationPolicy } from "../Enumerations/AuthorizationPolicy_pb";

/**
 * Describes the file Options/MethodOptions.proto.
 */
export const file_Options_MethodOptions: GenFile = /*@__PURE__*/
  fileDesc("ChtPcHRpb25zL01ldGhvZE9wdGlvbnMucHJvdG86hQEKFGF1dGhvcml6YXRpb25fcG9saWN5Eh4uZ29vZ2xlLnByb3RvYnVmLk1ldGhvZE9wdGlvbnMYpNv5ASABKA4yLy50aW1lX3RyYWNraW5nLmVudW1lcmF0aW9ucy5BdXRob3JpemF0aW9uUG9saWN5UhNhdXRob3JpemF0aW9uUG9saWN5QiSqAiFNb2dpLlRpbWVUcmFja2luZy5Db21tb24uTWVzc2FnZXNiBnByb3RvMw", [file_google_protobuf_descriptor, file_Enumerations_AuthorizationPolicy]);

/**
 * Specifies the ASP.net Core authorization policy to apply to the method call.
 *
 * @generated from extension: time_tracking.enumerations.AuthorizationPolicy authorization_policy = 4091300;
 */
export const authorization_policy: GenExtension<MethodOptions, AuthorizationPolicy> = /*@__PURE__*/
  extDesc(file_Options_MethodOptions, 0);

